import React, { useCallback, useEffect, useRef, useState } from "react";
import Companies from "./Companies/Companies";
import ShipperReceiver from "./ShipperReceiver/ShipperReceiver";
import Broker from "./Broker/Broker";
import AddBroker from "./AddBroker";
import AddCompanies from "./AddCompanies";
import Receiver from "./Receiver";
import { useLocation } from "react-router-dom";
import Csvfile from "./Csvfile";
import CsvFileCustomer from "./CsvFileCustomer";
import CsvFileShippers from "./CsvFileShippers";
import Search from "../../components/serchcomponet/search";
import AddButton from "../../components/UIElements/AddButton";
import PrimaryButton from "../../components/UIElements/PrimaryButton";
import AddBoxTruck from "./AddBoxTruck";
import BoxTruckTable from "./BoxTruckTable";

const BusinessBookView = () => {
  const location = useLocation();
  let backpage = location?.state?.selectedTab;

  const [selectedRows, setSelectedRows] = useState<any>([]);
  const [selectedRows1, setSelectedRows1] = useState<any>([]);
  const [selectedRows2, setSelectedRows2] = useState<any>([]);
  const [selectedRowsBoxTruck, setSelectedRowsBoxTruck] = useState<any>([]); // ← new
  const [selectedPriorities, setSelectedPriorities] = useState<any>([]);
  const [selectedPrioritiesBoxTruck, setSelectedPrioritiesBoxTruck] = useState<any>([]);

  const hide1: any = useRef<any>(null);
  const hide2: any = useRef<any>(null);
  const hide3 = useRef<any>(null);
  const hideBoxTruck = useRef<any>(null); // ← new modal ref
  const Brokerref: any = useRef(null);
  const Companiesref: any = useRef(null);
  const ShipperReceiverref: any = useRef(null);
  const BoxTruckref: any = useRef(null); // ← new table ref

  const [SingleBroker, setSingleBroker] = useState("");
  const [SingleCustomer, setSingleCustomer] = useState("");
  const [SingleShipper, setSingleShipper] = useState("");

  const [selectedTab, setSelectedTab] = useState<any>(1);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalOpen2, setIsModalOpen2] = useState(false);
  const [isModalOpen1, setIsModalOpen1] = useState(false);

  const [search, setSearch] = useState("");
  const [search1, setSearch1] = useState("");
  const [search2, setSearch2] = useState("");

  const [singleUser, setsingleUser] = useState<any>("");
  const [singleUser1, setsingleUser1] = useState<any>("");
  const [singleUser2, setsingleUser2] = useState<any>("");

  const [showBoxTruckModal, setBoxTruckModal] = useState(false);
  const [boxTruckObj, setBoxTruckObj] = useState<any>(null); // ← typed as any
  const searchDebounceRef = useRef<number | null>(null);

  const clickTab = (tabIndex: React.SetStateAction<number>) => {
    setSelectedTab(tabIndex);
  };

  const debouncedSearch = useCallback((callback: () => void) => {
    if (searchDebounceRef.current) {
      window.clearTimeout(searchDebounceRef.current);
    }

    searchDebounceRef.current = window.setTimeout(() => {
      callback();
    }, 400);
  }, []);

  useEffect(() => {
    return () => {
      if (searchDebounceRef.current) {
        window.clearTimeout(searchDebounceRef.current);
      }
    };
  }, []);

  // ── Modal close handlers ──────────────────────────────────────────────────
  const closeModal = () => setIsModalOpen(false);
  const closeModal2 = () => setIsModalOpen2(false);
  const closeModal1 = () => setIsModalOpen1(false);

  const closeBoxTruckModal = () => {
    setBoxTruckModal(false);
    setBoxTruckObj(null); // reset so next open is "Add" mode
  };

  // ── Refresh helpers ───────────────────────────────────────────────────────
  const getDataALLs = () => Brokerref?.current?.getDataALLBrokerref();
  const getDataALLs1 = () => Companiesref?.current?.getDataALLCompanies();
  const getDataALLs2 = useCallback(() => ShipperReceiverref?.current?.getDataALL(), []);
  const getDataALLsBoxTruck = () => BoxTruckref?.current?.getDataALLBoxTruckRef(); // ← new

  // ── Add / Edit modal openers ──────────────────────────────────────────────
  const addEditModelBroker = (data?: any) => {
    setSingleBroker(data || "");
    setIsModalOpen(true);
  };

  const addEditModelCustomer = (data?: any) => {
    setSingleCustomer(data || "");
    setIsModalOpen1(true);
  };

  const addEditModelShipper = (data?: any) => {
    setSingleShipper(data || "");
    setIsModalOpen2(true);
  };

  const addEditModelBoxTruck = (data?: any) => {
    setBoxTruckObj(data || null);
    setBoxTruckModal(true);
  };

  // ── Bulk delete handlers ──────────────────────────────────────────────────
  const handleDeleteSelected = () => Brokerref?.current?.handleDeleteSelected();
  const handleDeleteSelected2 = () => Companiesref?.current?.handleDeleteSelected2();
  const handleDeleteSelected3 = () => ShipperReceiverref?.current?.handleDeleteSelected3();
  const handleDeleteSelectedBoxTruck = () => BoxTruckref?.current?.handleDeleteSelected(); // ← new

  const AllDelete = () => Brokerref?.current?.handleDeleteSelectedAll();
  const AllDelete2 = () => Companiesref?.current?.handleDeleteSelectedAll2();
  const AllDelete3 = () => ShipperReceiverref?.current?.handleDeleteSelectedAll3();
  const AllDeleteBoxTruck = () => BoxTruckref?.current?.handleDeleteSelectedAll(); // ← new

  // ── Search handlers ───────────────────────────────────────────────────────
  const handleSearchChange = (value: string) => {
    setSearch(value);
    Brokerref.current?.handleSearchChange(value);
    debouncedSearch(() => Brokerref.current?.handleSearchSubmit());
  };
  const handleSearchSubmit = () => Brokerref?.current?.handleSearchSubmit();

  const handleSearchChangeCustomer = (value: string) => {
    setSearch1(value);
    Companiesref.current?.handleSearchChange(value);
    debouncedSearch(() => Companiesref.current?.handleSearchSubmit());
  };
  const handleSearchSubmitCustomer = () => Companiesref?.current?.handleSearchSubmit();

  const handleSearchChangeShippe = (value: string) => {
    setSearch2(value);
    ShipperReceiverref.current?.handleSearchChange(value);
    debouncedSearch(() => ShipperReceiverref.current?.handleSearchSubmit());
  };
  const handleSearchSubmitShippe = () => ShipperReceiverref?.current?.handleSearchSubmit();

  // ── Sample file downloads ─────────────────────────────────────────────────
  const handleDownload = () => {
    const link = document.createElement("a");
    link.href = `${process.env.PUBLIC_URL}/Simplefiles/Sample.csv`;
    link.download = "Sample.csv";
    link.click();
  };
  const handleDownload2 = () => {
    const link = document.createElement("a");
    link.href = `${process.env.PUBLIC_URL}/Simplefiles2/Sample2.csv`;
    link.download = "Sample.csv";
    link.click();
  };
  const handleDownload3 = () => {
    const link = document.createElement("a");
    link.href = `${process.env.PUBLIC_URL}/Simplefiles3/Sample3.csv`;
    link.download = "Sample.csv";
    link.click();
  };

  return (
    <>
      <div className="rightside">
        <div className="allscreen">
          <div className="loadlisting">
            <div className="loads-head-card">
              <div className="flex-gap">
                <img src="assets/img/business-book.svg" alt="" />
                <div className="load-dispatched">
                  <h6 className="dispatched-title">Business Book</h6>
                </div>
              </div>

              {/* ── Per-tab header actions ── */}
              <div className="loadsheadcard">
                {selectedTab === 1 && (
                  <div className="loadsheadcard">
                    <Search
                      search={search}
                      onSearchChange={handleSearchChange}
                      onClick={handleSearchSubmit}
                      placeholder="Search by name, address, phone number, DOT, MC"
                    />
                    <AddButton label="Add Broker" onClick={addEditModelBroker} />
                  </div>
                )}

                {selectedTab === 4 && (
                  <div className="loadsheadcard">
                    <AddButton
                      label="Add Box Truck"
                      onClick={() => addEditModelBoxTruck()}
                    />
                  </div>
                )}

                {selectedTab === 2 && (
                  <div className="loadsheadcard">
                    <Search
                      search={search1}
                      onSearchChange={handleSearchChangeCustomer}
                      onClick={handleSearchSubmitCustomer}
                      placeholder="Search by name, address, phone number, DOT, MC"
                    />
                    <AddButton label="Add Customer" onClick={addEditModelCustomer} />
                  </div>
                )}

                {selectedTab === 3 && (
                  <div className="loadsheadcard">
                    <Search
                      search={search2}
                      onSearchChange={handleSearchChangeShippe}
                      onClick={handleSearchSubmitShippe}
                      placeholder="Search by name, address, phone number, DOT, MC"
                    />
                    <AddButton label="Add Vendor" onClick={addEditModelShipper} />
                  </div>
                )}
              </div>
            </div>

            <div className="loadlist">
              <div className="flex-between p-3">
                {/* ── Tab buttons ── */}
                <div className="flex-gap">
                  <div className="loadbg">
                    {[
                      { label: "Broker", value: 1 },
                      { label: "Customer", value: 2 },
                      { label: "Box Truck", value: 4 },
                      { label: "Vendor", value: 3 },
                    ].map(({ label, value }) => (
                      <button
                        key={value}
                        className={`px-2 py-[6px] text-sm lg:px-4 lg:py-[6px] rounded-md font-medium shadow-sm
                          ${selectedTab === value
                            ? "bg-greenBg text-white"
                            : "bg-customGray hover:bg-greenBg hover:text-white"
                          }`}
                        onClick={() => clickTab(value)}
                      >
                        {label}
                      </button>
                    ))}
                  </div>
                </div>

                {/* ── Toolbar buttons ── */}
                <div className="grid grid-cols-4 gap-4 items-center">
                  {/* Broker toolbar */}
                  {selectedTab === 1 && (
                    <>
                      <Csvfile getDataALLs={() => getDataALLs()} />
                      <PrimaryButton label="Sample File" onClick={handleDownload} />
                      <PrimaryButton
                        disabled={selectedRows.length === 0}
                        label="Delete Selected"
                        bgColorClass="bg-[#e99197]"
                        onClick={handleDeleteSelected}
                      />
                      <PrimaryButton
                        label="All Delete"
                        bgColorClass="bg-[#dc3535f2]"
                        onClick={AllDelete}
                      />
                    </>
                  )}

                 

                  {/* Customer toolbar */}
                  {selectedTab === 2 && (
                    <>
                      <CsvFileCustomer getDataALLs1={() => getDataALLs1()} />
                      <PrimaryButton label="Sample File" onClick={handleDownload2} />
                      <PrimaryButton
                        disabled={selectedRows1.length === 0}
                        label="Delete Selected"
                        bgColorClass="bg-[#e99197]"
                        onClick={handleDeleteSelected2}
                      />
                      <PrimaryButton
                        label="All Delete"
                        bgColorClass="bg-[#dc3535f2]"
                        onClick={AllDelete2}
                      />
                    </>
                  )}

                  {/* Vendor toolbar */}
                  {selectedTab === 3 && (
                    <>
                      <CsvFileShippers getDataALLs2={() => getDataALLs2()} />
                      <PrimaryButton label="Sample File" onClick={handleDownload3} />
                      <PrimaryButton
                        disabled={selectedRows2.length === 0}
                        label="Delete Selected"
                        bgColorClass="bg-[#e99197]"
                        onClick={handleDeleteSelected3}
                      />
                      <PrimaryButton
                        label="All Delete"
                        bgColorClass="bg-[#dc3535f2]"
                        onClick={AllDelete3}
                      />
                    </>
                  )}
                </div>
              </div>

              {/* ── Tab content ── */}
              {selectedTab === 1 && (
                <Broker
                  ref={Brokerref}
                  setSelectedRows={setSelectedRows}
                  selectedRows={selectedRows}
                  addEditModelBroker={addEditModelBroker}
                  setSelectedPriorities={setSelectedPriorities}
                />
              )}

              {selectedTab === 4 && (
                <BoxTruckTable
                  ref={BoxTruckref}
                  setSelectedRows={setSelectedRowsBoxTruck}
                  selectedRows={selectedRowsBoxTruck}
                  addEditModelBoxTruck={addEditModelBoxTruck}
                  setSelectedPriorities={setSelectedPrioritiesBoxTruck}
                />
              )}

              {selectedTab === 2 && (
                <Companies
                  ref={Companiesref}
                  setSelectedRows1={setSelectedRows1}
                  selectedRows1={selectedRows1}
                  addEditModelCustomer={addEditModelCustomer}
                />
              )}

              {selectedTab === 3 && (
                <ShipperReceiver
                  setSelectedRows1={setSelectedRows2}
                  selectedRows1={selectedRows2}
                  addEditModelShipper={addEditModelShipper}
                  ref={ShipperReceiverref}
                />
              )}
            </div>
          </div>
        </div>
      </div>

      {/* ── Modals ── */}
      <AddBroker
        isOpen={isModalOpen}
        openModal={SingleBroker}
        closeModal={closeModal}
        ref={hide3}
        getDataALLs={getDataALLs}
        selectedPriorities={selectedPriorities}
      />

      <AddCompanies
        isOpen={isModalOpen1}
        openModal={SingleCustomer}
        closeModal={closeModal1}
        ref={hide2}
        getDataALLs={getDataALLs1}
      />

      <Receiver
        isOpen={isModalOpen2}
        openModal={SingleShipper}
        closeModal={closeModal2}
        ref={hide1}
        getDataALLs={getDataALLs2}
      />

      <AddBoxTruck
        isOpen={showBoxTruckModal}
        openModal={boxTruckObj}        // null = Add mode, object = Edit mode
        closeModal={closeBoxTruckModal}
        ref={hideBoxTruck}
        getDataALLs={getDataALLsBoxTruck}
        selectedPriorities={selectedPrioritiesBoxTruck}
      />
    </>
  );
};

export default BusinessBookView;